/**
 * Reti di servizio da nascondere negli elenchi (Rete, IPAM, Routing): il
 * loopback `127.0.0.0/8` e il blocco `255.0.0.0/8` (broadcast/riservato) sono
 * rumore per chi guarda — non sono dispositivi né rotte utili. Il filtro è di
 * sola vista: i dati restano, semplicemente non si mostrano.
 *
 * Accetta un IP o un CIDR ("10.0.0.1", "127.0.0.0/8"); gli IPv6 non sono mai
 * nascosti (il primo ottetto non si applica).
 */
export function reteNascosta(ip: string | null | undefined): boolean {
  if (!ip) return false
  const primo = ip.split('/')[0].split('.')[0]
  return primo === '127' || primo === '255'
}
